import { Button, IconButton } from "@material-ui/core";
import GetApp from "@material-ui/icons/GetApp";
import React, { useRef, useEffect, useState } from "react";
import { downloadMediaFile, mediaFileName } from "../../utils/downloadMedia";
import useAuthenticatedMedia from "../../hooks/useAuthenticatedMedia";

const LS_NAME = 'audioMessageRate';

const AudioModal = ({ url }) => {
  const audioRef = useRef(null);
  const [audioRate, setAudioRate] = useState(parseFloat(localStorage.getItem(LS_NAME) || "1"));
  const [showButtonRate, setShowButtonRate] = useState(false);
  const [sourceUrl, setSourceUrl] = useState(url);
  const [fallbackTried, setFallbackTried] = useState(false);
  const authenticatedUrl = useAuthenticatedMedia(sourceUrl);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  useEffect(() => {
    setSourceUrl(isIOS && String(url || "").includes(".ogg") ? String(url).replace(/\.ogg(?=\?|$)/i, ".mp3") : url);
    setFallbackTried(false);
  }, [url, isIOS]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.playbackRate = audioRate;
    localStorage.setItem(LS_NAME, audioRate);
  }, [audioRate]);

  useEffect(() => {
    if (!audioRef.current) return undefined;

    audioRef.current.onplaying = () => setShowButtonRate(true);
    audioRef.current.onpause = () => setShowButtonRate(false);
    audioRef.current.onended = () => setShowButtonRate(false);

    return () => {
      if (!audioRef.current) return;
      audioRef.current.onplaying = null;
      audioRef.current.onpause = null;
      audioRef.current.onended = null;
    };
  }, []);

  const toggleRate = () => {
    let newRate = null;

    switch (audioRate) {
      case 0.5: newRate = 1; break;
      case 1: newRate = 1.5; break;
      case 1.5: newRate = 2; break;
      case 2: newRate = 0.5; break;
      default: newRate = 1; break;
    }

    setAudioRate(newRate);
  };

  const handleAudioError = () => {
    if (fallbackTried) return;
    const original = String(url || "");
    if (/\.ogg(?=\?|$)/i.test(original)) {
      setFallbackTried(true);
      setSourceUrl(original.replace(/\.ogg(?=\?|$)/i, ".mp3"));
    }
  };

  const handleDownload = async () => {
    try {
      await downloadMediaFile(url, mediaFileName(url));
    } catch (err) {
      console.error("Erro ao baixar áudio:", err);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <audio
        ref={audioRef}
        controls
        src={authenticatedUrl || undefined}
        onError={handleAudioError}
      />
      {showButtonRate && (
        <Button size="small" onClick={toggleRate}>
          {audioRate}x
        </Button>
      )}
      <IconButton size="small" onClick={handleDownload} title="Baixar áudio">
        <GetApp fontSize="small" />
      </IconButton>
    </div>
  );
};

export default AudioModal;
